import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class Customer extends BaseInstitutionEntity {
    name: string;
    organisationId: string;
    peopleIds: string[];
    entityIdentifier: EntityIdentifier;
    entityIdentifiers: EntityIdentifier[];
}